document.addEventListener("DOMContentLoaded", function () {
  const MOBILE_MQ = "(max-width: 699px)";
  const mq = window.matchMedia(MOBILE_MQ);

  const initCarousel = () => {
    const inner = document.querySelector(".logo-list__inner");
    const track = document.querySelector(".logo-list__track:not(.clone)");
    const clone = document.querySelector(".logo-list__track.clone");

    if (!inner || !track || !clone) return;

    // duplicate original track content
    clone.innerHTML = track.innerHTML;

    let position = 0;
    const baseSpeed = 1;
    let speed = baseSpeed;
    let lastTime = performance.now();
    let rafId = null;
    let isDragging = false;
    let dragStartX = 0;
    let startPos = 0;
    let velocity = 0;
    let lastX = 0;
    let momentum = false;

    const applyTransform = () => {
      inner.style.transform = `translate3d(${position}px,0,0)`;
    };

    const tick = (now) => {
      const delta = now - lastTime;
      if (!isDragging) {
        if (momentum) {
          position += velocity;
          velocity *= 0.95;
          if (Math.abs(velocity) < 0.1) momentum = false;
        } else {
          position -= speed * (delta / 16);
        }

        const trackWidth = track.scrollWidth;
        if (-position >= trackWidth) {
          position += trackWidth;
        } else if (position > 0) {
          position -= trackWidth;
        }

        applyTransform();
      }
      lastTime = now;
      rafId = requestAnimationFrame(tick);
    };

    // --- Drag / Momentum Support ---
    const startDrag = (clientX) => {
      isDragging = true;
      dragStartX = clientX;
      startPos = position;
      velocity = 0;
      lastX = clientX;
      momentum = false;
    };

    const moveDrag = (clientX) => {
      if (!isDragging) return;
      const delta = clientX - dragStartX;
      position = startPos + delta;
      const now = performance.now();
      const elapsed = now - lastTime || 16;
      velocity = ((clientX - lastX) / elapsed) * 20;
      lastX = clientX;
      applyTransform();
    };

    const endDrag = () => {
      if (!isDragging) return;
      isDragging = false;
      momentum = true;
    };

    inner.addEventListener("pointerdown", (e) => {
      if (e.pointerType === "mouse" && e.button !== 0) return;
      e.preventDefault();
      startDrag(e.clientX);
    });
    inner.addEventListener("pointermove", (e) => {
      if (!isDragging) return;
      e.preventDefault();
      moveDrag(e.clientX);
    });
    inner.addEventListener("pointerup", endDrag);
    inner.addEventListener("pointercancel", endDrag);

    inner.addEventListener("mouseenter", () => {
      if (!isDragging && !momentum) speed = 0;
    });
    inner.addEventListener("mouseleave", () => {
      if (!isDragging && !momentum) speed = baseSpeed;
    });

    window.addEventListener("resize", () => (position = 0));
    rafId = requestAnimationFrame(tick);
  };

  if (mq.matches) initCarousel();
  mq.addEventListener("change", (e) => {
    if (e.matches) initCarousel();
  });
});
